import { fieldType } from 'app/area/search-filters/constants';
import { getFieldId } from 'app/area/search-filters/filters/selectors';
import { Filter, CustomFilterType, FilterType, PredefinedFilter, PredefinedFilterType, FilterCommonValues, PredefinedIds } from 'app/area/search-filters/filters/types';
import { TextConfigurationTranslation } from '../../constants';
import { endpoints } from '../../endpoints';
import { filterId, predefinedFiltersId, queryFilters } from './constants';

export const predefinedFilters = (translation: TextConfigurationTranslation): PredefinedFilter => ({
  type: PredefinedFilterType.code,
  values: [{
    value: predefinedFiltersId.hideInactiveCodes,
    description: translation.hide_inactive_codes_filter
  }, {
    value: predefinedFiltersId.potentiallyUntranslated,
    description: translation.potentially_untranslated
  }]
});

export const defaultFilters = (translation: TextConfigurationTranslation,
  userLanguage: FilterCommonValues<number>): { [key: string]: FilterCommonValues<number>[] } => ({
    [PredefinedIds.include]: [{
      value: predefinedFiltersId.hideInactiveCodes,
      description: translation.hide_inactive_codes_filter
    }],
    [getFieldId(filterId.query, queryFilters.description)]: [{ value: 1 }],
    [getFieldId(filterId.query, queryFilters.longDescription)]: [{ value: 1 }],
    [getFieldId(filterId.language, fieldType.root)]: [userLanguage]
  });

export const codeFilters = (translation: TextConfigurationTranslation): Filter[] => [
  {
    id: filterId.codetable,
    label: translation.codetable,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeHierarchySubLevelWithCategory,
        categoryOptionsEndpoint: endpoints.translationTypes,
        categoryLoadOptionsParams: { limitFieldsTo: undefined },
        categoryOptionsParams: { limitFieldsTo: undefined },
        optionsParams: { category: undefined, levels: undefined, limitFieldsTo: undefined },
        optionsEndpoint: endpoints.codetableOptions,
        mapOptionsParams: mapCategoryIdToOptionParams
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.query,
    label: translation.description,
    fields: [
      {
        fieldTypeId: queryFilters.text,
        type: CustomFilterType.text,
        includeInSummary: true
      },
      {
        fieldTypeId: queryFilters.description,
        type: CustomFilterType.checkbox,
        includeInSummary: false,
        options: [{ value: 1, title: translation.description }]
      },
      {
        fieldTypeId: queryFilters.longDescription,
        type: CustomFilterType.checkbox,
        includeInSummary: false,
        options: [{ value: 1, title: translation.long_description }]
      }
    ],
    type: FilterType.CUSTOM
  },
  {
    id: filterId.codeId,
    label: translation.code,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.inputIntegerFilter,
        includeInSummary: true
      }
    ],
    type: FilterType.TEXT_RANGE
  },
  {
    id: filterId.language,
    label: translation.language,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.code,
        isHierarchy: false,
        optionsEndpoint: endpoints.languageOptions
      }
    ],
    type: FilterType.SELECTED_IDS
  }
];

interface MapCategoryIdToOptionParams {
  categoryId: number;
}

export const mapCategoryIdToOptionParams = ({ categoryId }: MapCategoryIdToOptionParams): object => ({ categoryId });
